<script setup lang="ts">
import { ref } from 'vue'

import Capsule from '@/components/common/Capsule.vue'
import PortfolioItem from './PortfolioItem.vue'

import type { PortfolioValues } from '@/data/dbghub'

interface IProps {
  data: PortfolioValues[]
  colors: {
    primary: string
    secondary: string
    tertiary: string
  }
  headerLogos?: {
    portfolioName: string
    logo: any
    logoProps: {
      [key: string]: string | number
    }
  }[]
  selectPortfolio?: Function
  expandedIndex?: number
}

const props = defineProps<IProps>()

const expandedIndex = ref(props.expandedIndex ?? 0)

const getLogo = (portfolioName: string) => {
  return props.headerLogos?.find((item) => item.portfolioName === portfolioName)
}

function handleSelectPortfolio(portfolioName: string) {
  if (!props.selectPortfolio) {
    return
  }
  props.selectPortfolio(portfolioName)
}
</script>

<template>
  <Capsule
    :isMain="false"
    mode="animated"
    :childrenCount="data.length"
    v-model:expandedIndex="expandedIndex"
    background="light"
  >
    <template v-for="(dataItem, index) in data" :key="index" #[index+1]>
      <PortfolioItem
        :speedometerData="[
          { label: 'Earned Value', value: dataItem.earnedValue, color: props.colors.primary },
          { label: 'Opportunity', value: dataItem.opportunity, color: props.colors.secondary }
        ]"
        :complianceData="
          dataItem.compliance?.map((i, index) => ({
            ...i,
            percentage: i.value * 100,
            color: index === 0 ? colors.primary : colors.secondary
          }))
        "
        :colorProps="colors"
        :expanded="expandedIndex === index"
        :position="index === 0 ? 'top' : index === data.length - 1 ? 'bottom' : 'center'"
        @click="handleSelectPortfolio(dataItem.portfolioName)"
      >
        <template #headerLogo>
          <component
            :is="getLogo(dataItem.portfolioName)?.logo"
            v-bind="getLogo(dataItem.portfolioName)?.logoProps"
          />
        </template>
        <template #title>
          <span
            v-if="!getLogo(dataItem.portfolioName)"
            class="title"
            :class="{ expanded: expandedIndex === index }"
            >{{ dataItem.portfolioName }}</span
          >
        </template>
        <template #logo>
          <slot name="logo" />
        </template>
      </PortfolioItem>
    </template>
  </Capsule>
</template>

<style scoped>
.title {
  font-size: var(--font-size-h2);
  font-weight: 600;
  padding-bottom: 5%;
}
.title.expanded {
  padding-bottom: 0%;
}
</style>
